import template from './cancel_leave_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class LeaveCancelHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.leave_types = ko.observableArray();
		this.holiday_types = ko.observableArray();
		this.count = ko.observable(0);
	};

	close()
	{
		this.dialog.close();
	}
};

class LeaveCancelHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new LeaveCancelHelpViewModel(this);
		this.bindings = bindings;
		let index = 0;
		this.incrementCounter = () => {
			return ++index;
		};
	};

	async init()
	{
		Utils.refresh_data_visible_roles();

		try {
			let option_types = {
				table: 'v_condensed_leave_types',
				schema: 'savanna',
				sortfield: 'hexcolor',
				sortorder: 'asc'
			}

			let res = await Grape.fetches.getJSON('/api/record', option_types);
			if (res.status !== 'ERROR')
			{
				this.viewModel.leave_types(res.records);

				let options = {
					table: 'v_condensed_holiday_types',
					schema: 'savanna',
					sortfield: 'hexcolor',
					sortorder: 'asc'
				}

				let result = await Grape.fetches.getJSON('/api/record', options);
				if (result.status !== 'ERROR')
				this.viewModel.holiday_types(result.records);
			}
		} catch (error)
		{
			Grape.alerts.alert({ type: 'error', title: 'Error', message: error.message });
			console.error(error)
		}
	};
};

export default {
	name: 'LeaveCancelHelp',
	dialog_class: LeaveCancelHelpPage,
	template: template,
	template_filename: 'translation/dialogs/approve_leave_help',
	provider: 'ps'
};
